"use client";

import chameleon from "@chamaeleonidae/chmln";
import { useEffect } from "react";
import { SelfUser } from "@/api/users";

export function ChameleonIdentifyUser({
  me,
  uidHash,
}: {
  me: SelfUser;
  uidHash: string;
}) {
  useEffect(() => {
    const {
      id,
      created_at,
      email,
      industry_id,
      insights_enabled,
      name,
      opportunities_enabled,
      roles,
      salesforce_enabled,
      speaker_identification_enabled,
      user_organization_id,
      user_organization_name,
    } = me;

    chameleon.identify(id, {
      company: {
        name: user_organization_name,
        uid: user_organization_id,
      },
      created: created_at,
      email,
      industry_id,
      insights_enabled,
      name,
      opportunities_enabled,
      roles: roles.map((r) => r.name),
      salesforce_enabled,
      speaker_identification_enabled,
      uid_hash: uidHash,
    });
  }, [me, uidHash]);

  return null;
}

export default function ClientChameleonInit({ token }: { token: string }) {
  useEffect(() => {
    chameleon.init(token, {
      fastUrl: "https://fast.chameleon.io/",
    });
  }, [token]);

  return null;
}
